import orderBy from 'lodash/orderBy';
import { loadIpsStatus } from 'app/actions/dictionaries.actions';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import * as api from 'dashboard/resources/alerts.api';
import template from './alerts-widget.html';

/* Redux */
const mapStateToThis = ({ session, dictionaries }) => {
  const { retailer, locale } = session;
  const { ipsStatuses } = dictionaries;

  return {
    retailer,
    locale,
    ipsStatuses,
  };
};

const mapDispatchToThis = {
  loadIpsStatus,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class AlertsWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.showChainBtn = this.retailer.isChain;
    await this.loadIpsStatus();
    this.refreshData();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  refreshData() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    const transformDataFunction = (data) => {
      this.alertsNumber = data ? data.length : 0;
      return orderBy(data, ['read', 'priority', 'date'], ['asc', 'asc', 'desc']);
    };
    return this.loadDataAsync(() => api.fetchAlerts(retailerId, this.locale), transformDataFunction.bind(this));
  }
}

export default class AlertsWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = AlertsWidgetController;
    this.bindings = {
      isEditMode: '<',
      isDisabledShare: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/alerts/alerts-widget-component.js